import { Group, Text, Box, ActionIcon } from "@mantine/core";
import React from "react";

type TextWithInfoProps = {
  text: string;
  icon: React.ReactNode;
  textSize?: string;
};

export const CustomModalTitle: React.FC<TextWithInfoProps> = ({
  text,
  icon,
  textSize = "md",
}) => (
  <Group gap="xs" justify="flex-start" wrap="nowrap">
    {icon}
    <Text size={textSize}>{text}</Text>
  </Group>
);
